import {
  INewProductTrackingData,
  IProductTrackingData,
} from '@models/IProductTrackingData';

const mapToNewTrackingData = (
  trackingData: IProductTrackingData,
  options?: {
    listingName?: string;
    hideIndex?: boolean;
  }
): INewProductTrackingData => {
  const {
    name,
    nameEn,
    id,
    price,
    discount,
    brand,
    category,
    category2,
    category2En,
    variant,
    variantEn,
    position,
  } = trackingData;

  return {
    item_name: name,
    item_name_en: nameEn,
    item_id: id,
    price,
    discount,
    item_brand: brand,
    item_category: category,
    item_category2: category2,
    item_category2_en: category2En,
    item_variant: variant,
    item_variant_en: variantEn,
    ...(options?.hideIndex ? {} : { index: position }),
    ...(options?.listingName ? { item_list_name: options.listingName } : {}),
  };
};

export default mapToNewTrackingData;
